/**
 * @generated SignedSource<<bfa095d234481064ed74fd72c8193e75>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "boId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BusinessBeneficialOwnerDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteBeneficialOwnerTPayload",
        "kind": "LinkedField",
        "name": "deleteBeneficialOwnerTByBoId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BeneficialOwnerT",
            "kind": "LinkedField",
            "name": "beneficialOwnerT",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BusinessBeneficialOwnerDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteBeneficialOwnerTPayload",
        "kind": "LinkedField",
        "name": "deleteBeneficialOwnerTByBoId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BeneficialOwnerT",
            "kind": "LinkedField",
            "name": "beneficialOwnerT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0bab0b3cc50716a9a9d43c3cac9a3426",
    "id": null,
    "metadata": {},
    "name": "BusinessBeneficialOwnerDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation BusinessBeneficialOwnerDeleteMutation(\n  $input: DeleteBeneficialOwnerTByBoIdInput!\n) {\n  deleteBeneficialOwnerTByBoId(input: $input) {\n    beneficialOwnerT {\n      boId\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "d46f1118f3af3f6b38ff429fc645febc";

module.exports = node;
